import React from 'react';
import { Tabs } from 'antd';
import NotificationTemplatesTab from '../components/settings/NotificationTemplatesTab';
import NotificationSendTab from '../components/settings/NotificationSendTab';

const { TabPane } = Tabs;

// Eskiden Ayarlar altindaydi - sube muduru de kullandigi icin (bkz.
// Ayarlar'in artik sadece admin-only olmasi) kendi sayfasina tasindi.
const Notifications = () => {
  return (
    <div>
      <h2 className="text-2xl font-bold mb-6">Bildirimler</h2>
      <Tabs defaultActiveKey="notification-send">
        <TabPane tab="Bildirim Gönder" key="notification-send">
          <NotificationSendTab />
        </TabPane>
        <TabPane tab="Bildirim Şablonları" key="notifications">
          <NotificationTemplatesTab />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default Notifications;
